export const API_URL = 'https://api.gotmy.com/api/';
export const DEV_API_URL = 'https://dev.gotmy.com/api/';
export const HOST_URL = 'https://gotmy.com';
export const SOCKETIO_ENDPOINT = 'https://socket.dev.gotmy.com';
export const DEV_SOCKETIO_ENDPOINT = 'https://socket.prod.accesoevento.com';
export const EVENT_UUID = null;
export const BRAND_NAME = 'Televisa';
export const SUPPORT_EMAIL = 'support@accesoevento.com';
export const STRIPE_PUBLIC_KEY_DEV = 'pk_test_sbZ1LoDK09jqHS6QnHl1MrGb';
export const STRIPE_PUBLIC_KEY_LIVE = 'pk_live_jV1UJeHsXPP45NY7IW7l6vgR';
